import { Button, Divider, Group } from '@mantine/core'
import type { MantineStyleProps } from '@mantine/core'
import { Link } from '@remix-run/react'
import { BsLine } from 'react-icons/bs'

type LineButtonProps = {
  label: string
  link: string
  w?: MantineStyleProps['w']
  disabled?: boolean
  onClick?: () => void
}

export const LineButton = ({
  label,
  link,
  w,
  disabled,
  onClick,
}: LineButtonProps) => {
  return (
    <Button
      justify='space-between'
      leftSection={
        <Group px={0}>
          <BsLine size={36} color='secondary.1' />
          <Divider orientation='vertical' my={0} py={0} />
        </Group>
      }
      rightSection={<span />}
      size='xl'
      component={disabled ? undefined : Link}
      to={link}
      color='success.5'
      mah={80}
      w={w ? w : '100%'}
      fw='bold'
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </Button>
  )
}
